angular
    .module("app")
    .controller("riscattoAnticipatoCtrl", function (
        $scope,
        RichiestePostVendita,
        $transactionFactory,
        $rootScope
    ) {
        $scope.$rootScope = $rootScope;
        if (!$transactionFactory.get()) {
            $scope.richiestePostVendita = RichiestePostVendita.build();
        } else {
            $scope.richiestePostVendita = $transactionFactory.get();
            $transactionFactory.clear();
        }
    });